var map = {
	"./dining-room.mp3": 244,
	"./kitchen.mp3": 245,
	"./living-room.mp3": 246,
	"./mainsound.mp3": 247,
	"./outside.mp3": 248,
	"./suite.mp3": 249,
	"./wc.mp3": 250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 243;